import { render, staticRenderFns } from "./BlockStatsList.vue?vue&type=template&id=db7ae3d6&"
import script from "./BlockStatsList.vue?vue&type=script&lang=js&"
export * from "./BlockStatsList.vue?vue&type=script&lang=js&"
import style0 from "./BlockStatsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports